import { render } from "preact";
import { App } from "./App";
import { css } from "./styles";

function init() {
  let root = document.getElementById("iskra-chat-root");
  if (!root) {
    root = document.createElement("div");
    root.id = "iskra-chat-root";
    const script = (document.currentScript ||
      document.querySelector('script[src*="iskra-chat.js"]')) as HTMLScriptElement | null;
    root.dataset.stokeApi = script?.dataset.stokeApi || "";
    root.dataset.n8nEscalation = script?.dataset.n8nEscalation || "";
    document.body.appendChild(root);
  }

  // Inject styles
  if (!document.getElementById("iskra-chat-styles")) {
    const style = document.createElement("style");
    style.id = "iskra-chat-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }

  render(<App />, root);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
